import React from 'react'
import classnames from 'classnames'

import styles from './options.module.scss'

const Options = ({ options, value, onChange }) => (
  <div className={styles.container}>
    {options.map((option) => (
      <div
        key={option.value}
        tabIndex={0}
        className={classnames({
          [styles.option]: value !== option.value,
          [styles.selected]: value === option.value,
        })}
        onClick={() => onChange(option.value)}
        onKeyDown={(e) => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault()
            onChange(option.value)
          }
        }}
      >
        <div className={styles.text}>
          <div
            className={classnames({ [styles.active]: value === option.value })}
          />{' '}
          <span>{option.label}</span>
        </div>
      </div>
    ))}
  </div>
)

export default Options
